import { render, staticRenderFns } from "./AssessmentProjectsList.vue?vue&type=template&id=e2ebe9a0&"
import script from "./AssessmentProjectsList.vue?vue&type=script&lang=js&"
export * from "./AssessmentProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports